@if (showChrome()) {
  <!-- One shell and one outlet for both modes: swapping the outlet between layouts would destroy
       and re-create the page on every switch (e.g. Exit from the application form). -->
  <div class="app-shell"
       [class.focus-mode]="focusMode()"
       [class.awaiting-approval]="awaitingApproval()"
       [class.sidebar-collapsed]="wallet.sidebarCollapsed()"
       [class.mobile-open]="wallet.mobileSidebarOpen()">
    @if (!focusMode()) {
      <app-sidebar />
      @if (wallet.mobileSidebarOpen()) {
        <div class="mobile-backdrop" (click)="wallet.closeMobileSidebar()"></div>
      }
    }
    <div class="main-area">
      @if (focusMode()) { <app-focus-header /> } @else { <app-header /> }
      <main class="main-content">
        <router-outlet />
      </main>
      @if (!focusMode() && !awaitingApproval()) { <app-bottom-nav /> }
    </div>
  </div>
} @else {
  <router-outlet />
}
